













import Vue from 'vue'
import { ActionInterface, AntrfileIconElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'AntrfileIconEl',
  props: {
    templateItemData: {
      type: Object as () => AntrfileIconElInterface,
      required: true
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },
  computed: {
    style (): string {
      return 'background: ' + this.templateItemData.backgroundColor + '; ' +
        'color: ' + this.templateItemData.textColor + ' !important; ' +
        `${typeof this.templateItemData.action !== 'undefined' ? 'cursor: pointer; ' : ' '}`
    }
  }
})
